module.exports = __webpack_public_path__ + "img/finish.824f05b2.svg";